import React from 'react';

interface PageHeaderProps {
  breadcrumb?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

/** In-content page header used when shell header is generic (search + avatar). */
const PageHeader: React.FC<PageHeaderProps> = ({ breadcrumb, title, subtitle, actions }) => (
  <div className="toolbar" style={{ marginBottom: 20 }}>
    <div>
      {breadcrumb && <div className="breadcrumb">{breadcrumb}</div>}
      <h1 className="page-title" style={{ marginTop: 2 }}>{title}</h1>
      {subtitle && <div className="page-subtitle">{subtitle}</div>}
    </div>
    {actions && <div className="cta-row">{actions}</div>}
  </div>
);

export default PageHeader;
